import React from 'react';

const RenaperStepErrorMessage = (props) => {
    return (
        <p className={'error'}>
            Algo salió mal. Por favor reintenta el paso nuevamente.
        </p>
    );
}

export default RenaperStepErrorMessage;


/** WEBPACK FOOTER **
 ** ./src/components/RenaperStepErrorMessage.js
 **/